import { NgModule } from '@angular/core';
import { WrapEmailAddressAtPipe } from './wrap-email-address-at.pipe';

@NgModule({
  declarations: [ WrapEmailAddressAtPipe ],
  exports: [ WrapEmailAddressAtPipe ]
})
export class WrapEmailAddressAtModule {}
